// libs
import { styled } from '@nykaa/ui-components';

// mixins
import { resetButton } from 'shared/styles/mixin';

export const Container = styled.div``;

export const Button = styled.button`
  ${resetButton}

  position: relative;
  display: block;
  width: 100%;
  text-align: left;

  &:focus-visible {
    outline: 1px solid ${({ theme }) => theme.colors.secondary};
    outline-offset: -2px;
  }
`;

export const ExpanderIconWrapper = styled.span`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 11px;
  height: 11px;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const Content = styled.div`
  overflow: hidden;
  transition: height 0.25s linear;
`;
